import { render } from "./IotSoftwareComponent.vue?vue&type=template&id=d8154212"
import script from "./IotSoftwareComponent.vue?vue&type=script&lang=js"
export * from "./IotSoftwareComponent.vue?vue&type=script&lang=js"

import "./IotSoftwareComponent.vue?vue&type=style&index=0&id=d8154212&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__